"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
document.addEventListener("DOMContentLoaded", function() {
    var table = document.querySelector("table");
    var tbody = table.querySelector("tbody");
    var headers = table.querySelectorAll("thead th");
    var notification = document.createElement("div");
    notification.setAttribute("data-qa", "notification");
    document.body.appendChild(notification);
    var sortState = {};
    headers.forEach(function(th, index) {
        th.addEventListener("click", function() {
            var rows = Array.from(tbody.querySelectorAll("tr"));
            var asc = sortState[index] !== "asc";
            rows.sort(function(a, b) {
                var valA = a.children[index].innerText.replace(/[$,]/g, "");
                var valB = b.children[index].innerText.replace(/[$,]/g, "");
                var isNumA = valA.trim() !== "" && !Number.isNaN(Number(valA));
                var isNumB = valB.trim() !== "" && !Number.isNaN(Number(valB));
                if (isNumA && isNumB) {
                    valA = Number(valA);
                    valB = Number(valB);
                    return asc ? valA - valB : valB - valA;
                }
                return asc ? valA.localeCompare(valB) : valB.localeCompare(valA);
            });
            tbody.innerHTML = "";
            rows.forEach(function(r) {
                return tbody.appendChild(r);
            });
            sortState = _define_property({}, index, asc ? "asc" : "desc");
        });
    });
    tbody.addEventListener("click", function(e) {
        var row = e.target.closest("tr");
        if (row) {
            tbody.querySelectorAll("tr").forEach(function(r) {
                return r.classList.remove("active");
            });
            row.classList.add("active");
        }
    });
    var form = document.createElement("form");
    form.className = "new-employee-form";
    form.innerHTML = "\n  <label>Name: <input name='name'\n type='text' data-qa='name'></label>\n <label>Position: <input name='position' type='text' data-qa='position'></label>\n <label>Office:\n <select name='office' data-qa='office'>\n <option>Tokyo</option>\n <option>Singapore</option>\n<option>London</option>\n <option>New York</option>\n <option>Edinburgh</option>\n <option>San Francisco</option>\n\n </select>\n </label>\n <label>Age: <input name='age' type='number' data-qa='age'></label>\n\n <label>Salary: <input name='salary' type='number' data-qa='salary'></label>\n <button type='submit'>Save to table</button>\n  ";
    document.body.appendChild(form);
    var showNotification = function(msg, type) {
        notification.textContent = msg;
        notification.className = type;
    };
    form.addEventListener("submit", function(e) {
        e.preventDefault();
        var data = Object.fromEntries(new FormData(form));
        var employeeName = data.name.trim();
        var position = data.position.trim();
        var office = data.office;
        var age = Number(data.age);
        var salary = Number(data.salary);
        if (employeeName.length < 4) {
            showNotification("Name must be at least 4 characters long", "error");
            return;
        }
        if (!position.trim()) {
            showNotification("Position is required", "error");
            return;
        }
        if (age < 18 || age > 90) {
            showNotification("Age must be between 18 and 90", "error");
            return;
        }
        if (!office.trim()) {
            showNotification("Office is required", "error");
            return;
        }
        if (data.salary.trim() === "" || !Number.isFinite(salary)) {
            showNotification("Salary is required", "error");
            return;
        }
        var tr = document.createElement("tr");
        tr.innerHTML = "\n      <td>".concat(employeeName, "</td>\n      <td>").concat(position, "</td>\n      <td>").concat(office, "</td>\n      <td>").concat(age, "</td>\n      <td>$").concat(salary.toLocaleString("en-US"), "</td>\n    ");
        tbody.appendChild(tr);
        showNotification("Employee added successfully", "success");
        form.reset();
    });
    tbody.addEventListener("dblclick", function(e) {
        var cell = e.target;
        if (cell.tagName === "TD" && !cell.querySelector("input")) {
            var existingInput = document.querySelector(".cell-input");
            if (existingInput) {
                var parentCell = existingInput.parentElement;
                var oldValue = existingInput.value || parentCell.dataset.oldValue;
                parentCell.innerText = existingInput.value.trim() || oldValue;
            }
            var currentValue = cell.innerText;
            var input = document.createElement("input");
            input.value = currentValue;
            input.className = "cell-input";
            cell.dataset.oldValue = currentValue;
            cell.innerHTML = "";
            cell.appendChild(input);
            input.focus();
            var save = function() {
                cell.innerText = input.value.trim() || currentValue;
            };
            input.addEventListener("blur", save);
            input.addEventListener("keydown", function(ev) {
                if (ev.key === "Enter") save();
            });
        }
    });
});

//# sourceMappingURL=index.8f01bb97.js.map
